/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { environment } from 'environments/environment';

function extensionAction(): void {
  const dataSource = environment.dataSource;

  if (dataSource.includes('beta') || dataSource.includes('rc')) {
    const link = document.createElement('a');
    link.href = `${environment.urlToDownloadExtension}/AIVA_Monitor_Chrome_Extension.zip`;
    link.download = 'AIVA Monitor - Chrome Extension';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    window.open(
      'https://chromewebstore.google.com/detail/call-monitoring-extension/eaadiejhphbngapjnpbgcljclgkcdllj',
      '_blank'
    );
  }
}

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'NAVIGATION.dashboard',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/dashboard',
  },
  //   {
  //     id: 'execution-logs',
  //     title: 'Execution Logs',
  //     type: 'basic',
  //     icon: 'heroicons_outline:play',
  //     link: '/execution-logs',
  //   },
  {
    id: 'performance-analytics',
    title: 'NAVIGATION.performanceAnalytics',
    type: 'basic',
    icon: 'heroicons_outline:chart-bar',
    link: '/performance-analytics',
  },
  {
    id: 'interaction-tracking',
    title: 'NAVIGATION.interactionTracking',
    type: 'basic',
    icon: 'heroicons_outline:cursor-arrow-ripple',
    link: '/interaction-tracking',
  },
  {
    id: 'admin-settings',
    title: 'NAVIGATION.adminSettings',
    type: 'collapsable',
    icon: 'heroicons_outline:cog-8-tooth',
    children: [
      {
        id: 'admin-settings.partners',
        title: 'NAVIGATION.partners',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/settings/accounts',
      },
      {
        id: 'admin-settings.accounts',
        title: 'NAVIGATION.accounts',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: '/settings/subaccounts',
      },
      {
        id: 'admin-settings.onboarding',
        title: 'ONBOARDING_WIZARD.onboardingWizard',
        type: 'basic',
        icon: 'heroicons_outline:plus-circle',
        link: '/settings/onboarding',
      },
      {
        id: 'admin-settings.personality',
        title: 'NAVIGATION.personality',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-left-right',
        link: '/settings/personality',
      },
      {
        id: 'admin-settings.repair-cost-estimates',
        title: 'NAVIGATION.repairCostEstimates',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/settings/repair-cost-estimates',
      },
      {
        id: 'admin-settings.financing-estimates',
        title: 'NAVIGATION.financingEstimates',
        type: 'basic',
        icon: 'heroicons_outline:banknotes',
        link: '/settings/financing-estimates',
      },
      // AIVA-2143: voice call costs, budgets and rate cards — platform admins
      // only (filtered in navigation/api.ts; the route and API enforce it too).
      {
        id: 'admin-settings.usage-budget',
        title: 'NAVIGATION.usageBudget',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/settings/usage-budget',
      },
      {
        id: 'admin-settings.stt-corrections',
        title: 'NAVIGATION.sttCorrections',
        type: 'basic',
        icon: 'heroicons_outline:microphone',
        link: '/settings/stt-corrections',
      },
      // AIVA-2113: platform-wide vehicle make/model list used to correct a
      // vehicle make the AI got wrong on AIVA2 conversations.
      {
        id: 'admin-settings.vehicle-reference',
        title: 'NAVIGATION.vehicleReference',
        type: 'basic',
        icon: 'heroicons_outline:truck',
        link: '/settings/vehicle-reference',
      },
      // Per-dealer customer and vehicle list, checked ahead of the DMS on an
      // AIVA2 conversation.
      {
        id: 'admin-settings.customer-lookup',
        title: 'NAVIGATION.customerLookup',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/settings/customer-lookup',
      },
      // Voice-to-voice bake-off results — gated by environment.voiceBakeoff
      // (local + beta only), so it never appears in production. Lives under
      // Admin Settings so it inherits that section's audience instead of
      // carrying an admin-only gate of its own. Reads the ai-engine
      // bakeoff_runs read API.
      ...(environment.voiceBakeoff
        ? [
            {
              id: 'admin-settings.voice-bakeoff',
              title: 'Voice Pipeline Evaluation',
              type: 'basic',
              icon: 'heroicons_outline:microphone',
              link: '/voice-bakeoff',
            } as FuseNavigationItem,
          ]
        : []),
    ],
  },
  {
    id: 'download-extension',
    title: 'Download Extension',
    type: 'basic',
    icon: 'heroicons_outline:arrow-down-tray',
    function: () => extensionAction(),
    classes: {
      wrapper: 'download-extension-class',
    },
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'NAVIGATION.dashboard',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/dashboard',
  },
  {
    id: 'interaction-tracking',
    title: 'NAVIGATION.interactionTracking',
    type: 'basic',
    icon: 'heroicons_outline:cursor-arrow-ripple',
    link: '/interaction-tracking',
  },
  {
    id: 'admin-settings',
    title: 'NAVIGATION.adminSettings',
    type: 'collapsable',
    icon: 'heroicons_outline:cog-8-tooth',
    meta: { startCollapsed: true },
    children: [
      {
        id: 'admin-settings.partners',
        title: 'NAVIGATION.partners',
        subtitle: 'NAVIGATION.visibleToSuperAdmin',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/settings/accounts',
      },
      {
        id: 'admin-settings.accounts',
        title: 'NAVIGATION.accounts',
        subtitle: 'NAVIGATION.visibleToSuperAdminAndPartnerAdmin',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: '/settings/subaccounts',
      },
      {
        id: 'admin-settings.onboarding',
        title: 'ONBOARDING_WIZARD.onboardingWizard',
        type: 'basic',
        icon: 'heroicons_outline:sparkles',
        link: '/settings/onboarding',
      },
      {
        id: 'admin-settings.personality',
        title: 'NAVIGATION.personality',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-left-right',
        link: '/settings/personality',
      },
      {
        id: 'admin-settings.repair-cost-estimates',
        title: 'NAVIGATION.repairCostEstimates',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/settings/repair-cost-estimates',
      },
      {
        id: 'admin-settings.financing-estimates',
        title: 'NAVIGATION.financingEstimates',
        type: 'basic',
        icon: 'heroicons_outline:banknotes',
        link: '/settings/financing-estimates',
      },
      // AIVA-2143: voice call costs, budgets and rate cards — platform admins
      // only (filtered in navigation/api.ts; the route and API enforce it too).
      {
        id: 'admin-settings.usage-budget',
        title: 'NAVIGATION.usageBudget',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/settings/usage-budget',
      },
    ],
  },
  {
    id: 'download-extension',
    title: 'Download Extension',
    type: 'basic',
    icon: 'heroicons_outline:arrow-down-tray',
    function: () => extensionAction(),
    classes: { wrapper: 'download-extension-class' },
  },
];

export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'NAVIGATION.dashboard',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/dashboard',
  },
  {
    id: 'interaction-tracking',
    title: 'NAVIGATION.interactionTracking',
    type: 'basic',
    icon: 'heroicons_outline:cursor-arrow-ripple',
    link: '/interaction-tracking',
  },
  {
    id: 'admin-settings',
    title: 'NAVIGATION.adminSettings',
    type: 'collapsable',
    icon: 'heroicons_outline:cog-8-tooth',
    meta: { startCollapsed: true },
    children: [
      {
        id: 'admin-settings.partners',
        title: 'NAVIGATION.partners',
        subtitle: 'NAVIGATION.visibleToSuperAdmin',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/settings/accounts',
      },
      {
        id: 'admin-settings.accounts',
        title: 'NAVIGATION.accounts',
        subtitle: 'NAVIGATION.visibleToSuperAdminAndPartnerAdmin',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: '/settings/subaccounts',
      },
      {
        id: 'admin-settings.onboarding',
        title: 'ONBOARDING_WIZARD.onboardingWizard',
        type: 'basic',
        icon: 'heroicons_outline:sparkles',
        link: '/settings/onboarding',
      },
      {
        id: 'admin-settings.personality',
        title: 'NAVIGATION.personality',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-left-right',
        link: '/settings/personality',
      },
      {
        id: 'admin-settings.repair-cost-estimates',
        title: 'NAVIGATION.repairCostEstimates',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/settings/repair-cost-estimates',
      },
      {
        id: 'admin-settings.financing-estimates',
        title: 'NAVIGATION.financingEstimates',
        type: 'basic',
        icon: 'heroicons_outline:banknotes',
        link: '/settings/financing-estimates',
      },
      // AIVA-2143: voice call costs, budgets and rate cards — platform admins
      // only (filtered in navigation/api.ts; the route and API enforce it too).
      {
        id: 'admin-settings.usage-budget',
        title: 'NAVIGATION.usageBudget',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/settings/usage-budget',
      },
    ],
  },
  {
    id: 'download-extension',
    title: 'Download Extension',
    type: 'basic',
    icon: 'heroicons_outline:arrow-down-tray',
    function: () => extensionAction(),
    classes: { wrapper: 'download-extension-class' },
  },
];

export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'NAVIGATION.dashboard',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/dashboard',
  },
  {
    id: 'interaction-tracking',
    title: 'NAVIGATION.interactionTracking',
    type: 'basic',
    icon: 'heroicons_outline:cursor-arrow-ripple',
    link: '/interaction-tracking',
  },
  {
    id: 'admin-settings',
    title: 'NAVIGATION.adminSettings',
    type: 'collapsable',
    icon: 'heroicons_outline:cog-8-tooth',
    meta: { startCollapsed: true },
    children: [
      {
        id: 'admin-settings.partners',
        title: 'NAVIGATION.partners',
        subtitle: 'NAVIGATION.visibleToSuperAdmin',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/settings/accounts',
      },
      {
        id: 'admin-settings.accounts',
        title: 'NAVIGATION.accounts',
        subtitle: 'NAVIGATION.visibleToSuperAdminAndPartnerAdmin',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: '/settings/subaccounts',
      },
      {
        id: 'admin-settings.onboarding',
        title: 'ONBOARDING_WIZARD.onboardingWizard',
        type: 'basic',
        icon: 'heroicons_outline:sparkles',
        link: '/settings/onboarding',
      },
      {
        id: 'admin-settings.personality',
        title: 'NAVIGATION.personality',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-left-right',
        link: '/settings/personality',
      },
      {
        id: 'admin-settings.repair-cost-estimates',
        title: 'NAVIGATION.repairCostEstimates',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/settings/repair-cost-estimates',
      },
      {
        id: 'admin-settings.financing-estimates',
        title: 'NAVIGATION.financingEstimates',
        type: 'basic',
        icon: 'heroicons_outline:banknotes',
        link: '/settings/financing-estimates',
      },
      // AIVA-2143: voice call costs, budgets and rate cards — platform admins
      // only (filtered in navigation/api.ts; the route and API enforce it too).
      {
        id: 'admin-settings.usage-budget',
        title: 'NAVIGATION.usageBudget',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/settings/usage-budget',
      },
    ],
  },
  {
    id: 'download-extension',
    title: 'Download Extension',
    type: 'basic',
    icon: 'heroicons_outline:arrow-down-tray',
    function: () => extensionAction(),
    classes: { wrapper: 'download-extension-class' },
  },
];
